module.exports = __webpack_public_path__ + "img/c.91bf496f.jpg";